import React, {useEffect, useState} from 'react';
import styles from './MenuBottom.scss';
import ButtonOrder from '@components/widgets/CustomButtons/ButtonOrder/ButtonOrder';
import ButtonChat from '@components/widgets/CustomButtons/ButtonChat/ButtonChat';
import DomainSearchForm from '@components/base/DomainSearchForm/DomainSearchForm';
//import ButtonSettings from "@components/widgets/CustomButtons/ButtonSettings/ButtonSettings";
import ButtonLeftOriginals from "@components/widgets/CustomButtons/ButtonLeftOriginals/ButtonLeftOriginals";
import language from "@lang/language";

const MenuBottom = ({
						serviceType = '',
						term = 12,
						yearPrice = false,
						customPrice = null,
						color = ''
					}) => {

	// Temporary stop
	//return null;

	const [isHeaderOut, setIsHeaderOut] = useState(false);
	const [isPricesIn, setIsPricesIn] = useState(false);

	const showCenterElement = isHeaderOut && !isPricesIn;

	///////////////////////////////////////////////////
	// Track header visibility
	///////////////////////////////////////////////////
	useEffect(() => {
		const menuHolder = document.getElementById('menuHolder');
		const headerContainer = menuHolder?.parentElement;
		if (!headerContainer) {
			return;
		}

		const observer = new IntersectionObserver(
		  ([entry]) => setIsHeaderOut(!entry.isIntersecting),
		  {threshold: 0}
		);
		observer.observe(headerContainer);
		return () => observer.disconnect();
	}, []);

	///////////////////////////////////////////////////
	// Track prices block visibility
	///////////////////////////////////////////////////
	useEffect(() => {
		const prices = document.getElementById('servicePrices');
		if (!prices) {
			return;
		}

		const observer = new IntersectionObserver(
		  ([entry]) => setIsPricesIn(entry.isIntersecting),
		  {threshold: 0}
		);
		observer.observe(prices);
		return () => observer.disconnect();
	}, []);

	///////////////////////////////////////////////////
	// Domain form settings
	///////////////////////////////////////////////////
	const domainForm = {
		placeHolder: 'www.mysupersite.com',
		buttonText: language.search,
		animationTexts: [
			"www.mysupersite.com",
			"www.mysupersite.bg",
			"www.mysupersite.eu",
			"www.mysupersite.net"
		]
	}

	return (
	  <div id="menuBottom" className={`${styles.container}`}>
		  {/* /////////////// LEFT CONTAINER /////////////// */}
		  {/*<div className={`${styles.elementsHolder} ${styles.leftElement}`}>*/}
		  {/*  <ButtonSettings/>*/}
		  {/*</div>*/}
		  <ButtonLeftOriginals className={`${styles.elementsHolder} ${styles.leftElement}`}/>

		  {/* /////////////// CENTER CONTAINER /////////////// */}
		  <div
			className={`${styles.elementsHolder} ${styles.centerElement} ${showCenterElement ? styles.visible : ''}`}>
			  {
				  serviceType
					? (
					  serviceType === 'DomainSearchForm' ?
						<DomainSearchForm
						  data={domainForm}
						  layout={'BottomMenu'}
						  buttonLayout={'defaultWhiteBorder'}
						  fromPage={'Domains'}
						  color={color}
						/>
						:
						<ButtonOrder
						  serviceType={serviceType}
						  term={term}
						  yearPrice={yearPrice}
						  customPrice={customPrice}
						/>
					)
					: null
			  }
		  </div>

		  {/* /////////////// RIGHT CONTAINER /////////////// */}
		  <div className={`${styles.elementsHolder} ${styles.rightElement}`}>
			  <ButtonChat/>
		  </div>
	  </div>
	);
};

export default MenuBottom;